module.exports = __webpack_public_path__ + "media/images/div_lens/inclusive-img3-535d788238ff73547a0682e738307f3c.jpg";